export default __webpack_public_path__ + "static/media/isbank.849c3ab8.png";